module.exports = __webpack_public_path__ + "img/pending-cand-feddback.a822dfb5.svg";